"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _hooks = require("@alycecom/hooks");

var ClearButton = (0, _material.styled)('button')({
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  width: '100%',
  textAlign: 'initial',
  cursor: 'pointer'
});
var styles = {
  root: {
    boxShadow: '0px 2px 5px rgba(51, 68, 124, 0.15)',
    mx: 2,
    mb: 4,
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'common.white'
  },
  title: {
    fontWeight: 700,
    color: 'link.main',
    lineHeight: '1.5rem'
  },
  subtitle: {
    fontWeight: 700,
    fontSize: '0.75rem',
    color: 'primary.light',
    lineHeight: '1rem'
  },
  description: {
    fontSize: '0.75rem',
    color: 'grey.chambray50',
    lineHeight: '1rem'
  },
  image: {
    width: 80,
    height: 80,
    backgroundColor: 'additional.chambray05',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

var BatchItem = function BatchItem(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      loading = _ref.loading,
      onDelete = _ref.onDelete,
      onClick = _ref.onClick;

  var _useModalState = (0, _hooks.useModalState)(),
      isOpen = _useModalState.isOpen,
      handleOpen = _useModalState.handleOpen,
      handleClose = _useModalState.handleClose;

  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.root
    }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: 112
    }));
  }

  var handleDelete = function handleDelete(event) {
    event.stopPropagation();
    handleOpen();
  };

  var handleConfirmDelete = function handleConfirmDelete() {
    if (onDelete) {
      onDelete();
    }

    handleClose();
  };

  var handleCancelDelete = function handleCancelDelete() {
    handleClose();
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ClearButton, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.root,
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.image
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    fontSize: 2,
    color: "yellow.sunflower",
    icon: "gift"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 auto",
    ml: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.title
  }, title), onDelete && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: handleDelete
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    color: "primary.main",
    fontSize: 0.75,
    icon: "trash-alt"
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.subtitle
  }, subtitle), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.description
  }, description))))), /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, {
    width: "100%",
    variant: "warning",
    isOpen: isOpen,
    title: "Are you sure you want to delete this gift batch?",
    onSubmit: handleConfirmDelete,
    onDiscard: handleCancelDelete,
    submitButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
    backdropStyles: {
      top: 0
    },
    DialogProps: {
      disablePortal: false
    }
  }));
};

var _default = BatchItem;
exports.default = _default;